import { PreferenceCenter } from "@ua/web-sdk/lib/remote-data/preference-center"
import { ScopedSubscriptionListIdentifier } from "@ua/web-sdk/lib/types"
import { SubscriptionList } from "./types"

export function isCrossChannel(pc: PreferenceCenter): boolean {
  return pc.sections?.some((section) =>
    section.items?.some(
      (item) =>
        item.type === "contact_subscription_group" ||
        item.type === "contact_subscription"
    )
  )
}

export function contactToSubscriptionList(
  lists: ScopedSubscriptionListIdentifier
): SubscriptionList[] {
  return Object.entries(lists).map(([id, scopes]) => ({ id, scopes }))
}

export function channelToSubscriptionList(lists: string[]): SubscriptionList[] {
  return lists.map((id) => ({ id }))
}
